import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

import { Container } from 'src/components/container';
import { ProductSelectCard } from 'src/components/product-select-card';
import { breakpointLargeTablet, breakpointTablet } from 'src/styles/breakpoints';
import { spacing1, spacing13, spacing18, spacing2, spacing3, spacing4, spacing5, spacing7 } from 'src/styles/spacing';

export const StyledProductSelectCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  @media (min-width: ${breakpointLargeTablet}) {
    flex-direction: row;
  }
`;

export const StyledProductSelectCard = styled(ProductSelectCard)`
  @media (min-width: ${breakpointLargeTablet}) {
    min-width: unset;
    flex: 1 1 0;

    &:not(:first-child) {
      margin-left: ${spacing3};
    }
  }
`;

export const StyledTitle = styled(Typography)`
  text-align: center;
  padding-bottom: ${spacing2};
  padding-top: ${spacing5};

  @media (min-width: ${breakpointTablet}) {
    padding-top: ${spacing5};
    padding-bottom: ${spacing3};
  }
`;

export const StyledSubTitle = styled(Typography)`
  text-align: center;
  padding-bottom: ${spacing4};

  @media (min-width: ${breakpointTablet}) {
    padding-bottom: ${spacing7};
  }
`;

export const StyledNote = styled(Typography)`
  text-align: left;
  padding-top: ${spacing1};

  @media (min-width: ${breakpointTablet}) {
    text-align: center;
  }
`;

export const StyledContainer = styled(Container)`
  margin-bottom: ${spacing13};

  @media (min-width: ${breakpointLargeTablet}) {
    margin-bottom: ${spacing18};
  }
`;
